/* eslint-disable @typescript-eslint/no-explicit-any */
import { combineReducers } from "redux";
import loginReducer from "./reducers/loginReducer";
import variableReducer from "./reducers/variableReducer";
import Dashboard from "./reducers/dashboardReducer";
import ActivityReducer from "./reducers/Dashboard/activityReducer";
import transferReducer from "./reducers/transferReducer";
import EurailTicketReducer from "./reducers/Dashboard/eurailTicketReducer";
import EurailPassReducer from "./reducers/Dashboard/eurailPassReducer";
import localStorageReducer from "./reducers/localStorage";

export interface RootState {
  login: {
    loginResponse: any;
    AgentContactDetails: any;
    GstStateCodes: any;
    CountriesCodes: any;
    CitiesCodes: any;
    CurrencyList: any;
    ForgotPasswordResponse: any;
    ResetPasswordResponse: any;
    ResetPasswordLSResponse: any;
    generatedAccessToken: any;
    ResendOTPResponse: any;
    VerifyOTPResponse: any;
    ChangePasswordResponse: any;
  };
  languageVariable: {
    value: any;
    languageDropDown: any;
    ipAddress: any;
  };
  Dashboard: {
    SearchLocList: any;
    CurrencyList: any;
    NationalityList: any;
    CityList: any;
    AgentsList: any; // TW
    AgentUsersList: any; // TW
    AgentCurrenciesList: any; // TW
    AgentProfileDetails: any; // TW
    mailTemplateData: any; // TW
    addMailLogData: any; // TW
    addUpdateBookingUploadData: any; // TW
    addUpdateBookingDraft: any; // TW
    bookingDrafByTWBidData: any; //  TW
    ThresholdLimitAdmin: any; // TW
    currencyConversionRates: any; // TW
    getAgentById: any; // TW
    addAgentQuoteData: any; // TW
    ActiveAgentsDetailsList: any; // TW
    IsDarkMode: boolean;
    HotelSearch: any;
    ProductSearchTimeExpire: any;
    validateDuplicateBookingData: any;
    AgentInvoice: any;
    AgentInfoFinalizeTransfer: any;
    PriceCalculateOCPC: any;
    PostPriceCalculate: any;
    AgentsByCurrency: any;
    agentsByCurrencyAndInvoiceEntity: any;
    BookingsList: any;
    addTransferToAgentDetails: any;
    AddFinalizeBookings: any;
    SearchHotelsList: any;
    HotelsAddresses: any;
    ExtraDetails: any;
    HotelLevelFilter: any;
    HotelInfo: any;
    HotelRates: any;
    SimilarHotels: any;
    RoomOptionsRates: any;
    GetHotelMultiRoomMeanRate: any;
    Airports: any;
    DropAirports: any;
    Airlines: any;
    Accommodations: any;
    DropAccommodations: any;
    DestinationDropdownDetails: any;
    DestinationToDropdownDetails: any;
    DestinationActivityDropdownDetails: any;
    callHotelListApi: boolean;
    callAddressesApi: boolean;
    callExtraDetailsApi: boolean;
    CurrentSuppliers: any;
    activitySuppliers: any;
    CancellationPolicy: any;
    BookingDetailsByBid: any;
    addPGTransactionDetails: any;
    generateHash512ActionDetails: any;
    featuredHotelsDetails: any;
    activityCancellationPolicyDetails: any;
    transferCancellationPolicyDetails: any;
    validatePANDetails: any;
    updateValidationStatusDetails: any;
    abandonReasonsDetails: any;
    bookableThresholdDetails: any;
    bookableCLDetails: any;
    bookableWBDetails: any;
    agentProfileByAgentIdData: any;
    configValueData: any;
    previewURLData: any;
    AgentAllWidgetsData: any;
    addUserSearchHistoryDetails: any;
    itineraryIdByTempIdDetails: any;
    getUserSearchHistoryDetails: any;
    postPaymentGatewayData: any;
    BookingdetailsByiternaryId: any;
    getDmcList: any;
    getDmcCitiesList: any;
    getDmcTourTypesList: any;
    getDmcPackagesList: any;
    getDmcPackDetailsList: any;
    zoholayoutdependencyMappings: any;
    zohoLayoutRules: any;
    CreateTicket: any;
    updatePGInvoiceNumberData: any;
    addBookingMailDetails: any;
    // Booking Process Starts here
    BookingIdDetails: any;
    RecheckPriceDetails: any;
    // BookingConfirmationDetails: any;
    HotelCheckoutDetails: any;
    // Booking Process Ends here
    focusMenu: any;
    // searchKey: string | null
    paymentGatewayTransactionsDetails: any;
    PaymentLink: any;
    voucherViewDetailsDetails: any;
    voucherViewEurailDetailsDetails: any;
    voucherViewTransferDetailsDetails: any;
    voucherViewActivityDetails: any;
    biDfromTempIdDetails: any;
    LoginURL: any;
    checkPanExistForAgentDetails: any;
    billingInvoice: any;
    ProformasInvoice: any;
    addDuplicateBookingMailData: any;
    finalizeBookingTransferAdmin: any;
    finalizedBookingTransferAgent: any;
    addTransferToAgentTransfer: any;
    getAccessNotificationsPermissions: any;
    GetRequestFailureReasonStatus: any;
  };
  ActivityReducer: {
    ActivitySearch: any;
    GetActivitiesListDetails: any;
    GetActivityExtraDetails: any;
    GetActivityAgeBand: any;
    GetActivityCategories: any;
    GetActivityAllDetails: any;
    GetActivityProductInfo: any;
    ActivityPreBookDetails: any;
    ActivityCheckoutDetails: any;
    callActivitiesListApi: boolean;
    callActivityExtraDetailsApi: boolean;
    callActivityAllDetailsApi: boolean;
    passportDetailsByBookingIdDetails: any;
  };
  Transfer: {
    TransferSearchDetails: any;
    TransferListDetails: any;
    SelectedTransfers: {
      departure: any | null;
      return: any | null;
    };
    TransferPrebookDetails: any;
    TransferCheckoutDetails: any;
  };
  EurailTicketReducer: {
    ETStationList: any;
    ETStationToList: any;
    EurailTicketSearch: any;
    GetEurailTicketList: any;
    EurailTicketPreBookDetails: any;
    EurailTicketCheckoutDetails: any;
    GetEurailConfigKey: any;
    EurailBookingDetailsByBid: any;
    AgentEurailBookingDetailsByBid: any;
    GetHSID: any;
    EurailSegmentCharges: any; 
  };
  EurailPassReducer: {
    EurailPassCountries: any;
    EurailPassSearch: any;
    GetEurailPassList: any;
    EurailPassPreBookDetails: any;
    EurailPassCheckoutDetails: any;
  };
  localStorageReducer: {
    CompareRooms: any;
    // LocalQuoteRooms: any;
    // LocalQuoteTransfers: any;
    // localQuoteActivities: any;
    UserQuoteRef: string;
    AddRoomsHotel: any;
    AddRoomsApartment: any;
    AddRoomsTransfer: any;
    AddRoomsActivity: any;
    AddETPax: any;
    AddEPPax: any;
    NotificationMessage: any;
    searchSuggestionType: any;
  };
}

export default combineReducers({
  login: loginReducer,
  languageVariable: variableReducer,
  Dashboard,
  ActivityReducer,
  Transfer: transferReducer,
  EurailTicketReducer,
  EurailPassReducer,
  localStorageReducer,
});
